import { BACKEND_API } from '@src/apiFetch/axiosConfig';

export const sendLoginFingerprint = async (visitorId: string, fingerprintData: unknown) => {
    try {
        await BACKEND_API.post('/login-events', {
            visitor_id: visitorId,
            fingerprint_data: fingerprintData,
        });
    } catch (err) {
        // Fire-and-forget — never block the user login flow
        console.error('Failed to send login fingerprint:', err);
    }
};
